"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultProps = exports.propTypes = exports.config = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/

/**
 * @fileoverview 组件参数配置
 */

/**
 * Icon 接口参数
 *  @property {titleline} 默认支持参数
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {titleline} 基础属性
 * @property {string} type='confirm' 类型（可选值参考下方）
 * @property {string} [size=''] 尺寸, 可选值: large, small, '',
 * @property {string} [name=''] svg图标名称
 * @property {bool} [solid=false] 是否实心（目前不是每个图标都有）
 * @example
 * type可选值:
 *  strongwarn, warn, success, confirm, tips, wrong || error,
 *  add, close or delete, arrow-up, arrow-down, arrow-left,
 *  arrow-right, checkmark, sort-asc, sort-desc
 */
var config = {
  type: {
    type: _spauiUtils.PropTypes.string.isRequired,
    defaultValue: 'confirm'
  },
  size: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: ''
  },
  name: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: ''
  },
  solid: {
    type: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.bool])
  }
}; // 转化成PureComponent组件的配置

exports.config = config;
var configData = (0, _spauiUtils.formatProps)(config); // 导出

var propTypes = configData.propTypes;
exports.propTypes = propTypes;
var defaultProps = configData.defaultProps;
exports.defaultProps = defaultProps;
var _default = {
  config: config,
  propTypes: propTypes,
  defaultProps: defaultProps
};
exports["default"] = _default;